import axios, { AxiosResponse } from 'axios';
import { ServerData } from '@/@types/base';
import { ISubscription, ISubscriptionInfo } from '@/@types/subscriptions';

export async function getSubscriptionsProducts() {
  const response: AxiosResponse<ServerData<ISubscription[]>> = await axios({
    method: 'GET',
    url: '/products',
    params: {
      platform: 'web',
    },
  });

  const {
    data: { success, data: subscriptionsData },
  } = response;

  if (!success) {
    throw new Error('api getSubscriptionsProducts success false');
  }

  return subscriptionsData;
}

export async function getSubscriptionInfo() {
  const response: AxiosResponse<ServerData<ISubscriptionInfo>> = await axios({
    method: 'GET',
    url: '/subscription/info',
  });

  const {
    data: { success, data: subscriptionsData },
  } = response;

  if (!success) {
    throw new Error('api getUserSubscription success false');
  }

  return subscriptionsData;
}
